import {
  CREATE_PRODUCT_SUCCESS,
  EDIT_PRODUCT_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCT_FAILURE,
} from '../actions/products';
import { showFlashMessage } from '../actions/ui';

const products =
  ({ dispatch }) =>
  next =>
  action => {
    switch (action.type) {
      case CREATE_PRODUCT_SUCCESS:
        dispatch(
          showFlashMessage('Product token created', {
            type: 'success',
          }),
        );
        break;
      case EDIT_PRODUCT_SUCCESS:
        dispatch(
          showFlashMessage('Product details updated', {
            type: 'success',
          }),
        );
        break;
      case FETCH_PRODUCTS_FAILURE:
      case FETCH_PRODUCT_FAILURE:
        dispatch(
          showFlashMessage(action.payload.message, {
            type: 'error',
          }),
        );
        break;

      default:
        break;
    }

    // keep the train moving!
    return next(action);
  };

export default products;
